import React from 'react';
import { X } from 'lucide-react';
import Button from './Button';
import './SimpleModal.css';

function SimpleModal({
  isOpen,
  onClose,
  title,
  message,
  body = null,
  type = 'info',
  actions = [],
  children,
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className='simple-modal-overlay' onClick={handleOverlayClick}>
      <div className={`simple-modal ${type}`}>
        <div className='modal-header'>
          <h3>{title}</h3>
          <button
            className='close-btn'
            onClick={onClose}
            aria-label='Close modal'
          >
            <X size={20} />
          </button>
        </div>

        <div className='modal-content'>
          {body}
          {message && <p className='modal-message'>{message}</p>}
          {children}
        </div>

        {actions.length > 0 && (
          <div className='modal-actions'>
            {actions.map((action, index) => (
              <Button
                key={index}
                type={action.type || 'secondary'}
                onClick={action.onClick}
                disabled={action.disabled}
              >
                {action.text}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SimpleModal;
